import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import fieldLogic from '../logic/fieldsLogic';
import Grid from '@material-ui/core/Grid';
import FormHelperText from '@material-ui/core/FormHelperText';
import { makeStyles } from '@material-ui/core/styles';
import Form from '../../../../form/field';
import RepositoryPicker from '../../../../core/RepositoryPicker';
import absolute from '../../../../utils/pathUtil/absolute';
import addDesignTrunk from '../../../../utils/pathUtil/addDesignTrunk';
import Button from '../../../../core/Button';
import Icon from '../../../../core/Icon';
import Utils from '../../../../utils';
/** Custom style in order to ensure the same UI between single and multiline inputs */

var useStyles = makeStyles({
  root: {// marginTop: 8,
    // marginBottom: 4,
  },
  container: {
    // marginTop: 8,
    // marginBottom: 4,
    position: 'relative',
    display: 'inline-block',
    maxWidth: '100%',
    '&:hover': {
      '& $image': {
        opacity: 0.3
      },
      '& $middle': {
        opacity: 1
      }
    }
  },
  middle: {
    transition: '.5s ease',
    opacity: 0,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '-ms-transform': 'translate(-50%, -50%)',
    'text-align': 'center'
  },
  image: {
    maxWidth: '100%',
    maxHeight: 400
  }
}, {
  name: 'ECImageInput'
});

var decode = function decode(pathAndWorkspace, basePath) {
  if (pathAndWorkspace === null) {
    return {
      workspace: null,
      path: null
    };
  } else if (typeof pathAndWorkspace === 'string') {
    if (pathAndWorkspace.indexOf('/') > -1) {
      var segments = pathAndWorkspace.split('/');
      var workspace = segments.shift();
      var path = addDesignTrunk(segments.join('/'));
      return {
        workspace: workspace,
        path: absolute(path, basePath)
      };
    }
  } else if (typeof pathAndWorkspace === 'object') {
    var _workspace = pathAndWorkspace.workspace || null;

    var _path = pathAndWorkspace.path || null;

    if (!_path) {
      return {
        workspace: _workspace,
        path: null
      };
    }

    return {
      workspace: _workspace,
      path: absolute(_path, basePath)
    };
  }

  return {
    workspace: null,
    path: null
  };
};

var ImageInput = function ImageInput(_ref) {
  var fieldId = _ref.fieldId,
      value = _ref.value,
      dispatch = _ref.dispatch,
      readonly = _ref.readonly,
      error = _ref.error,
      folder = _ref.folder,
      workspace = _ref.workspace,
      disableRepositoryAccess = _ref.disableRepositoryAccess,
      optimize = _ref.optimize;
  var classes = useStyles({});

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      toggle = _React$useState2[1];

  var optimizeImageWeb = optimize && optimize !== 'none';
  var widthHeightMaxLimit = optimize && optimize !== 'none' && optimize !== 'auto' ? parseInt(optimize) : -1;

  var closePicker = function closePicker() {
    return toggle(false);
  };

  var openPicker = function openPicker() {
    // focus the field when show the picker
    fieldLogic.onFocus(fieldId, dispatch);
    toggle(true);
  };

  var _onChange = function onChange(value) {
    fieldLogic.onChange(fieldId, value, dispatch);
  };

  var onDelete = function onDelete() {
    // focus the field when you remove the data
    fieldLogic.onFocus(fieldId, dispatch);

    _onChange('');
  };

  var onLocalFileChange = function onLocalFileChange(value) {
    if (!value) return;
    var formData = new FormData();
    formData.append('file', value);
    Utils.request({
      method: 'POST',
      url: '/backend/upload',
      data: formData
    }).then(function (content) {
      var mimeType = Utils.path.getFileMimeType(value.path || value.name || '');
      var imageBase64 = "data:".concat(value.type || mimeType, ";base64,").concat(content);

      _onChange(imageBase64);
    });
  };

  return React.createElement(React.Fragment, null, value && React.createElement("div", {
    className: classes.container
  }, React.createElement("img", {
    src: value,
    className: classes.image
  }), !readonly && React.createElement("div", {
    className: classes.middle
  }, disableRepositoryAccess && React.createElement(Form.Input.LocalFile, {
    onChange: onLocalFileChange,
    accept: "image/*"
  }, React.createElement(Icon, {
    type: "style",
    onClick: function onClick() {},
    label: "Browse image"
  })), !disableRepositoryAccess && React.createElement(Icon, {
    type: "style",
    onClick: openPicker,
    label: "Browse image"
  }), React.createElement(Icon, {
    type: "delete",
    onClick: onDelete,
    label: "Remove image"
  }))), !value && !disableRepositoryAccess && React.createElement(Grid, {
    classes: {
      root: classes.root
    }
  }, React.createElement(Button, {
    variant: "outlined",
    color: "default",
    disabled: readonly,
    onClick: openPicker
  }, "Browse"), React.createElement(FormHelperText, {
    error: !!error,
    margin: "dense"
  }, error || ' ')), !value && disableRepositoryAccess && React.createElement(Grid, null, React.createElement(Form.Input.LocalFile, {
    onChange: onLocalFileChange,
    accept: "image/*",
    disabled: readonly
  }, React.createElement(Button, {
    variant: "outlined",
    color: "default",
    disabled: readonly
  }, "Browse")), React.createElement(FormHelperText, {
    error: !!error,
    margin: "dense"
  }, error || ' ')), open && React.createElement(RepositoryPicker, {
    fileTypes: ['image'],
    maxUploadSize: 100 * 1024 * 1024,
    optimizeImageWeb: optimizeImageWeb,
    widthHeightMaxLimit: widthHeightMaxLimit,
    onChange: function onChange(selection) {
      if (selection.length) {
        var _decode = decode(selection[0]),
            filePath = _decode.path,
            fileWorkspace = _decode.workspace;

        Utils.apiClients.content.getContent(fileWorkspace, filePath, true).then(function (base64File) {
          var mimeType = Utils.path.getFileMimeType(filePath);
          var imageBase64 = "data:".concat(mimeType, ";base64,").concat(base64File);

          _onChange(imageBase64);
        });
      } else {
        onDelete();
      }

      closePicker();
    },
    allowImageFromCamera: true,
    lockWorkspace: true,
    path: folder,
    workspace: workspace,
    onClose: closePicker
  }));
};

ImageInput.defaultProps = {
  variant: 'standard'
};
export default React.memo(ImageInput);